import EventBus from './EventBus';

export const TASK_EVENTS = {
  UPDATED: 'updated task',
};

export function dispatchTaskUpdated(newTaskName: string) {
  EventBus.dispatch(TASK_EVENTS.UPDATED, newTaskName);
}
